import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../utils/data/essential";
import { useFetchData } from "../../hooks/useFetchData";
import { reconciliationDetailsColumns } from "../../utils/columns/reconciliationDetails";
const ReconDetails = ({ reconPeriod, sendDataToParent }) => {
  const user = JSON.parse(localStorage.getItem("user"))
  // Fetch reconciliation data
  const url = `operators/100001/reconciliations/${reconPeriod}`;
  const { data } = useFetchData(["recon-details"], url,true,user);
  const emitData = () => {
    sendDataToParent(data[0]?.status);
  };
  useEffect(() => {
    if (data) {
      emitData()
    }
  },[data])
  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Reconciliation</h3>
      </div>
      <div
        className='table-responsive datatables dataValidation-Wrap'
        style={{ width: "100%" }}
      >
        <DataTable
          columns={reconciliationDetailsColumns}
          data={data}
          responsive={true}
          customStyles={customStyles}
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
    </div>
  );
};
export default ReconDetails;
